/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { getSessionStorage } from '../../Authentication/Actions/authentication';

const lg = '#D8E4BC';
const p16 = '16px';
const userName = getSessionStorage('user_name');

const DownloadDraftInsights = (props) => {
  const { insightsData, draftData } = props;
  const [insights, setInsights] = useState([]);
  const [tableTopInfo, setTableTopInfo] = useState([]);

  useEffect(() => {
    let insights = [];

    if (insightsData?.length) {
      const insightsTableData = insightsData?.map((insight) => {
        const clauseText = insight?.clauseData
          ?.map((text, index) => `${index + 1}). ${text?.sentence} ,`)
          ?.join('\n');
        if (draftData?.extraction_type === 'kdp') {
          return {
            'Clause Type': insight?.clauseType,
            'Clause Text': clauseText,
          };
        } else {
          return {
            'Clause Type': insight?.clauseType,
            Summary: insight?.summary
              ?.map((summaryText, index) => `${index + 1}). ${summaryText} ,`)
              ?.join('\n'),
            'Clause Text': clauseText,
          };
        }
      });
      insights = insightsTableData;
    }

    setInsights(insights);
  }, [insightsData]);

  useEffect(() => {
    const date = new Date().toISOString();

    setTableTopInfo([
      { key: 'Stylus Draft ID', value: draftData?.id },
      {
        key: 'Initiated By[Groups]',
        value: `${draftData?.created_by?.first_name} ${draftData?.created_by?.last_name} (${draftData?.created_by?.groups.join(', ')})`,
      },
      {
        key: 'Downloaded On',
        value: `${dayjs(date).format('DD/MM/YYYY, h:mm A')} IST`,
      },
      { key: 'Downloaded By', value: userName ? userName : '' },
      {
        key: 'Project Name',
        value: draftData?.projects?.map((project) => project?.name).join(', '),
      },
      {
        key: 'File Name',
        value: draftData?.contractName,
      },
      {
        key: 'Counter Party Name',
        value: draftData?.counter_party_name,
      },
    ]);
  }, [draftData]);

  return (
    <>
      <Typography
        marginLeft={2}
        onClick={() => {
          let link = document.getElementById('test-table-xls-button');
          link && link.click();
        }}
      >
        Insights as XLS
      </Typography>
      <div style={{ display: 'None' }}>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="btn btn-warning btn-sm"
          table="table-to-xls"
          filename={`${draftData?.contractName}_insights`}
          sheet="insights"
          buttonText="Download Insights"
        />
      </div>
      <table
        id="table-to-xls"
        style={{ display: 'none', fontFamily: 'Cambria Math' }}
      >
        <tbody>
          <RenderTableTopInfo tableTopInfo={tableTopInfo} />

          <tr>
            <td style={{ width: '369px' }}></td>
            {draftData?.extraction_type === 'ai' && (
              <td style={{ width: '424px' }}></td>
            )}
            <td style={{ width: '1000px' }}></td>
          </tr>
          <RenderHeader draftData={draftData} />
          {insights.map((ins, i) => {
            return (
              <tr key={i}>
                <td
                  style={{
                    textAlign: 'center',
                  }}
                >
                  {ins['Clause Type']}
                </td>
                {draftData?.extraction_type === 'ai' && (
                  <td>{ins['Summary']}</td>
                )}
                <td
                  style={{
                    padding: '10px',
                    width: '1000px',
                    textAlign: 'center',
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word !important',
                  }}
                >
                  {ins['Clause Text']}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
export default DownloadDraftInsights;

const RenderTableTopInfo = ({ tableTopInfo }) => {
  return (
    <>
      {tableTopInfo.map((info, i) => {
        return (
          <tr key={i}>
            <td></td>
            <td
              style={{
                backgroundColor: lg,
                fontSize: p16,
                fontWeight: 'bold',
                textAlign: 'center',
                color: info.color ? info.color : 'black',
                borderWidth: 1,
                borderColor: 'black',
                borderStyle: 'solid',
              }}
            >
              {info.key}
            </td>
            <td
              style={{
                backgroundColor: lg,
                fontSize: p16,
                fontWeight: 'bold',
                textAlign: 'center',
                color: info.color ? info.color : 'black',
                borderWidth: 1,
                borderColor: 'black',
                borderStyle: 'solid',
              }}
            >
              {info.value}
            </td>
          </tr>
        );
      })}
    </>
  );
};

const header = ['Clause Name', 'Summary', 'Clause Text'];
const kdpHeader = ['Clause Name', 'Clause Text'];

const RenderHeader = (headerProps) => {
  const lb = '#8DB4E2';
  const p14 = '14px';
  return (
    <tr>
      {headerProps?.draftData?.extraction_type === 'ai'
        ? header.map((head, i) => {
            return (
              <td
                style={{
                  backgroundColor: lb,
                  fontSize: p14,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
                key={i}
              >
                {head}
              </td>
            );
          })
        : kdpHeader.map((head, i) => {
            return (
              <td
                style={{
                  backgroundColor: lb,
                  fontSize: p14,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
                key={i}
              >
                {head}
              </td>
            );
          })}
    </tr>
  );
};
